//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    showSnackbar: false,
    snackbarMessage: "",
    snackbarColor: "success",

    tno: null,
    randDate: null,
    randTime: null,
    trialAllocation: null,
    deviceOffline: null,
  }),
  props: ["notify"],
  computed: {
    getTrialAllocation() {
      if (this.trialAllocation == 1) {
        return "SGA-Supraglottic airway device";
      } else if (this.trialAllocation == 2) {
        return "TI-Tracheal intubation";
      } else {
        return "No previous randomisation.";
      }
    },
    getRandType() {
      if (this.deviceOffline == 1) {
        return "Online";
      } else if (this.deviceOffline == 2) {
        return "Offline";
      } else {
        return "No previous randomisation.";
      }
    },
    getTNOcaption() {
      if (this.deviceOffline == 1) {
        return "Trial Number (TNO)";
      } else {
        return "Offline Temporary Trial Number (Offline-TNO)";
      }
    },
  },
  methods: {
    ...mapMutations(["setCrfTitle"]),
    ...mapActions(["fetchLatestRandResult"]),
    closeRandOutcome() {
      this.$router.push("/");
    },
  },
  async mounted() {
    this.setCrfTitle("Rand outcome");
    ({
      tno: this.tno,
      randDate: this.randDate,
      trialAllocation: this.trialAllocation,
      deviceOffline: this.deviceOffline,
    } = await this.fetchLatestRandResult());
    //notify
    if (this.notify) {
      this.snackbarColor = "success";
      this.snackbarMessage = "Participant randomised!";
      this.showSnackbar = true;
    }
  },
};
